import { WSElementProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { PayeeRow } from "@wingspanhq/wingspan-api-sdk";
import { mapPayablesTableToCSV } from "../../../Invoices/screens/payables/csvUtils";
import { PayablesFilter, paymentsService } from "../../../services/payments";
import { ButtonDownloadCsv } from "../../../shared/components/ButtonDownloadCsv";
import { getAllEntries } from "../../../utils/serviceHelper";

type Props = {
  payeeRows: PayeeRow[];
  filters: PayablesFilter;
  fileName: string;
} & WSElementProps;

export const DownloadCsv: React.FC<Props> = ({
  payeeRows,
  filters,
  fileName,
  ...elementProps
}) => {
  return (
    <ButtonDownloadCsv
      getData={async () => {
        const payables = await getAllEntries(
          async (...args) =>
            (await paymentsService.payable.list(...(args as any))).data,
          filters
        );

        return mapPayablesTableToCSV(
          payables.map(payable => ({
            payable,
            payeeRow: payeeRows.find(row => row.id === payable.memberId)
          }))
        );
      }}
      fileName={fileName}
      {...elementProps}
    />
  );
};
